import { A3innuvaTariffGroupCodeFragment } from 'generated/resources/graphql'

import { ContractFieldsProps } from '../lib/types'

export const getProfessionalCategory = (
  categories: ContractFieldsProps[],
  categoryId?: number
): ContractFieldsProps | undefined => {
  if (!categoryId) return

  return categories.find(({ id }) => id === categoryId)
}
export const getEducationLevel = (
  levels: ContractFieldsProps[],
  levelId?: number
): ContractFieldsProps | undefined => {
  return levels.find(({ id }) => id === levelId)
}

export const getCotizationGroup = (
  groups: A3innuvaTariffGroupCodeFragment[],
  groupId?: number
): A3innuvaTariffGroupCodeFragment | undefined => {
  return groups.find((group) => group.code === groupId)
}
